import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueScrollTo from 'vue-scrollto';
import Toasted from 'vue-toasted';

Vue.config.productionTip = false;
Vue.use(VueScrollTo);
Vue.use(Toasted, {
	position: 'bottom-center',
	theme: 'toasted-primary',
	duration: 5000,
	singleton: true
});
new Vue({
  el: '#app',
  data: { quoteType: null, siteLang: null },

  beforeMount: function() {
    if (this.$el.attributes['data-formtype']) {
			this.quoteType = this.$el.attributes['data-formtype'].value;
			this.siteLang = this.$el.attributes['data-sitelang'].value;
    }
    console.log(this.quoteType, this.siteLang);
    this.quoteType = this.quoteType || 'rca';
    this.siteLang = this.siteLang || 'ro';
  },

  vuetify,
	scrollTo,

  render: function(h) {
    return  h(App, { props:{ quoteFormType: this.quoteType, siteLanguage: this.siteLang} });
  }
});


